import { compose } from 'recompose';
import { withStyles } from '@material-ui/core';
import { reduxForm } from 'redux-form';
import Form from './Form';

const styles = ({ spacing }) => ({
    input: {
        marginRight: spacing(1),
        marginBottom: 0,
    },
    btnGrid: {
        textAlign: 'right',
    },
});

export default compose(
    withStyles(styles),
    reduxForm(),
)(Form);
